(() => {
  const STORAGE_KEY = 'wau:wishlist:product-handles';

  const readSet = () => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  };

  const writeSet = (set) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set)));
  };

  const applyState = () => {
    let set;
    try {
      set = readSet();
    } catch {
      set = new Set();
    }

    document
      .querySelectorAll('.product-loop__wishlist-btn[data-product-handle]')
      .forEach((btn) => {
        const handle = btn.getAttribute('data-product-handle');
        const active = !!handle && set.has(handle);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
  };

  const onClick = (e) => {
    const btn = e.target.closest('.product-loop__wishlist-btn[data-product-handle]');
    if (!btn) return;
    e.preventDefault();

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    try {
      const set = readSet();
      if (set.has(handle)) set.delete(handle);
      else set.add(handle);
      writeSet(set);
    } catch {
      // ignore storage/JSON errors
    }

    applyState();
  };

  const init = () => {
    applyState();
    document.addEventListener('click', onClick);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', applyState);
  document.addEventListener('shopify:section:select', applyState);
})();

